import type { ReactNode } from 'react';
import Layout from './Layout';
import PageLayoutProvider from './provider';

type PageProps = {
  children: ReactNode;
  fillHeight?: boolean;
};

export default function Page({ children, fillHeight = false }: PageProps) {
  return (
    <PageLayoutProvider>
      <Layout fillHeight={fillHeight}>{children}</Layout>
    </PageLayoutProvider>
  );
}
